<mat-form-field class="select-filter override-hide-placeholder" [matTooltip]="displayTooltip ? value.value : null"
  [matTooltipShowDelay]="1100" [ngClass]="classes" [class.has-orphaned-value]="!!orphanedOption">
  <mat-label>{{label}}</mat-label>
  <mat-select #filterSelect
    panelClass="select-search-dropdown-panel"
    (selectionChange)="emitConstantChangedComplete($event.value);"
    (click)="$event.stopPropagation()"
    (openedChange)="onOpen($event)"
    [formControl]="value"
    [compareWith]="filter_compare || compareByName"
    [allowFit]="allow_fit"
    [appFitContent]="app_fit_content"
    [ngStyle]="conditional_formats || formats?.style"
    [tabindex]="tab_index"
    [placeholder]="getPlaceholder()"
    [aria-describedby]="orphanedOption ? orphanedDescriptionId : null"
    >
    <div class="dropdown-container">
      <!-- Search Bar -->
      @if (options?.length > 5 || groupedOptions?.length) {
        <ng-container class="row center sticky">
          <option-list-search (keydown.space)="$event.stopPropagation()"
            [placeholder]="placeholder || 'Search'"
            [selectElementRef]="filterSelect"
            (inputChanged)="filterOptionList($event)"
            (inputCleared)="onClear()"
            [delay]="300">
          </option-list-search>
        </ng-container>
      }

      <!-- Error Message -->
      @if (filteredOptions?.length === 0 && filteredGroupedOptions?.length === 0) {
        <div class="row error">
          <span>{{ errorMessage }}</span>
        </div>
      }

      <!-- Options Rendering -->
      @for (option of filteredOptions; track option; let i = $index) {
        <ng-container class="row options">
          <!-- Null Option -->
          @if (!option?.attributes && !filterValue && i === 0) {
            <mat-option [value]="null"></mat-option>
          }
          <!-- Standard Option -->
          @if (option?.name && option?.value) {
            <mat-option
              [value]="option.value">
              {{ option.name | upperfirst }}
            </mat-option>
          } @else {
            <mat-option [value]="option">
              {{ stringFunction(option) | upperfirst }}
            </mat-option>
          }
          <!-- Default Template -->
        </ng-container>
      }
    </div>

    <!-- Grouped Options Rendering -->
    @for (group of filteredGroupedOptions; track group) {
      <mat-optgroup [label]="stringFunction(group.label) | upperfirst | removeUnderscore">
        @for (child of group.children; track child) {
          <mat-option [value]="child">
            {{ stringFunction(child) | upperfirst | removeUnderscore }}
          </mat-option>
        }
      </mat-optgroup>
    }

    <!-- Stored value with no matching option. Outside the loops above so it cannot skew the
         search-bar threshold, the filter, or the empty-list message. -->
    @if (orphanedOption) {
      <mat-option class="select-filter-orphaned-option"
                  [value]="orphanedOption.value"
                  [attr.aria-label]="orphanedOption.name + ', no longer an option'"
                  disabled>
        {{ orphanedOption.name }}
      </mat-option>
    }
  </mat-select>
</mat-form-field>
<!-- The trigger's accessible name comes from the form-field label alone, so the retired state
     needs its own description or it reaches assistive tech only as colour and italics. -->
@if (orphanedOption) {
  <span class="select-filter-orphaned-description cdk-visually-hidden" [id]="orphanedDescriptionId">
    no longer an option
  </span>
}
